const getCellErrors = (errors, columnName) => {
  return errors.find((error) => error[columnName])?.[columnName] || '';
};

const companyErrors = {
  Name: 'Name',
  Country: 'Country',
  City: 'City',
  Street: 'Street Address',
  Locale: 'State',
  Postal: 'Postal Code',
  Email: 'Email Address',
  ID: 'Company ID',
};

const companyCompoundErrorName = {
  Email: 2,
  Street: 3,
  Postal: 2,
};

const isColumnMatched = (columnName, requiredColumns) => {
  return requiredColumns.includes(columnName);
};

const parseErrors = (data = []) => {
  return data.map((error) => {
    let columnError = error.split(' ')[0];
    let formattedError = {};
    formattedError[companyErrors[columnError]] = error
      .split(' ')
      .slice(companyCompoundErrorName[columnError] || 1)
      .join(' ');
    return formattedError;
  });
};

const countUnmatched = (columns = [], requiredColumns = []) => {
  return columns.reduce((count, curr) => {
    if (!requiredColumns.includes(curr)) {
      count++;
    }
    return count;
  }, 0);
};

const buildCompanyFromJson = (rowData = {}) => {
  const rowDataFormatted = JSON.parse(rowData.json_data);
  return {
    ...rowDataFormatted,
    errors: parseErrors(rowDataFormatted.errors),
    id: rowData.id,
  };
};

export default {
  errors: companyErrors,
  getCellErrors,
  compoundErrorName: companyCompoundErrorName,
  parseErrors,
  buildFromJson: buildCompanyFromJson,
  isColumnMatched,
  countUnmatched,
};
